import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { forceCheck } from 'react-lazyload';
import throttle from 'lodash/throttle';

import Masonry from 'react-masonry-component';

import ContentCardList from '~/components/ContentCardList/ContentCardList';
import StyledComponent from '~/components/Styled/Styled';
import LoadMoreButton from '~/components/LoadMoreButton/LoadMoreButton';
import { operations as pageDataOperations } from '~/state/pageData';

import { intlShape, injectIntl } from 'react-intl';

import masonry from '~/static/css/masonry.css';
import messages from '~/constants/localizations/league_river';
import css from '~/components/RelatedNewsRiver/RelatedNewsRiver.scss';

class RelatedNewsRiver extends React.Component {
  async componentDidMount() {
    const masonryLayout = this.masonry.layout.bind(this.masonry);
    this.masonryLayout = throttle(masonryLayout, 500);
    window.addEventListener('image-loaded', this.masonryLayout);

    forceCheck();
  }

  componentWillUnmount() {
    window.removeEventListener('image-loaded', this.masonryLayout);
  }

  render() {
    const masonryOptions = {
      gutter: `.${masonry.gridGutter}`,
      itemSelector: `.${masonry.gridItem}`,
      columnWidth: `.${masonry.gridSizer}`,
      percentPosition: true,
      transitionDuration: 0,
    };
    const {
      resourceUri,
      relatedNews,
      isLoading,
      loadRelatedNews,
      showTitle,
      children,
      intl: { formatMessage },
    } = this.props;
    const riverCards = relatedNews.relatedContent;
    return (
      <div className={css.riverContainer}>
        {showTitle && (
          <h2 className={`${css.riverHeader} ${css.relatedNewsHeader}`}>
            {formatMessage(messages.related_news)}
          </h2>
        )}
        <Masonry
          disableImagesLoaded
          className={masonry.grid}
          options={masonryOptions}
          ref={c => {
            this.masonry = this.masonry || c.masonry;
          }}
        >
          <div className={masonry.gridSizer} />
          <div className={masonry.gridGutter} />
          <ContentCardList contentCards={riverCards.slice(0, 2)} />
          {children !== null && <div className={`${masonry.gridItem}`}>{children}</div>}
          <ContentCardList contentCards={riverCards.slice(2)} />
        </Masonry>
        <LoadMoreButton
          isLoading={isLoading}
          onClick={() => {
            loadRelatedNews({
              relatedUri: resourceUri,
              relatedNews,
            });
          }}
        />
      </div>
    );
  }
}

RelatedNewsRiver.propTypes = {
  resourceUri: PropTypes.string.isRequired,
  relatedNews: PropTypes.shape({
    relatedContent: PropTypes.array,
    before: PropTypes.string,
  }).isRequired,
  intl: intlShape.isRequired,
  isLoading: PropTypes.bool,
  loadRelatedNews: PropTypes.func.isRequired,
  showTitle: PropTypes.bool,
  children: PropTypes.node,
};

RelatedNewsRiver.defaultProps = {
  isLoading: false,
  showTitle: true,
  children: null,
};

RelatedNewsRiver.displayName = 'RelatedNewsRiver';

const mapStateToProps = state => ({
  relatedNews: state.pageData.relatedNews,
  isLoading: state.pageData.isLoading,
});

const mapDispatchToProps = dispatch => ({
  loadRelatedNews: bindActionCreators(pageDataOperations.loadRelatedNews, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(StyledComponent(RelatedNewsRiver, [css, masonry]))
);
